module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-card/theme/lui-card.global.scss
// module id = 376
// module chunks = 0 1 36